import React from 'react';

interface SparkleIconProps {
  size?: number;
  color?: string;
  className?: string;
  animated?: boolean;
}

const SparkleIcon: React.FC<SparkleIconProps> = ({ 
  size = 40, 
  color = '#06B6D4',
  className = '',
  animated = true
}) => {
  return (
    <>
      <svg 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        className={`sparkle-icon ${className}`}
        style={{ width: size, height: size }}
      >
        {/* Edges with varying lengths that change randomly */}
        <g className={animated ? "edge edge-1" : ""}><line x1="12" y1="12" x2="12" y2="2.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-2" : ""}><line x1="12" y1="12" x2="12" y2="21.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-3" : ""}><line x1="12" y1="12" x2="21.5" y2="12" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-4" : ""}><line x1="12" y1="12" x2="2.5" y2="12" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-5" : ""}><line x1="12" y1="12" x2="19" y2="5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-6" : ""}><line x1="12" y1="12" x2="19" y2="19" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-7" : ""}><line x1="12" y1="12" x2="5" y2="19" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-8" : ""}><line x1="12" y1="12" x2="5" y2="5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-9" : ""}><line x1="12" y1="12" x2="16.5" y2="3.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-10" : ""}><line x1="12" y1="12" x2="7.5" y2="3.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-11" : ""}><line x1="12" y1="12" x2="16.5" y2="20.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-12" : ""}><line x1="12" y1="12" x2="7.5" y2="20.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-13" : ""}><line x1="12" y1="12" x2="20.5" y2="7.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-14" : ""}><line x1="12" y1="12" x2="20.5" y2="16.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-15" : ""}><line x1="12" y1="12" x2="3.5" y2="7.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
        <g className={animated ? "edge edge-16" : ""}><line x1="12" y1="12" x2="3.5" y2="16.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" className="edge-line"/></g>
      </svg>

      {animated && (
        <style>{`
          .sparkle-icon {
            display: inline-block;
          }

          .edge {
            transform-origin: 12px 12px;
            animation: edgeLengthChange 4s ease-in-out infinite;
          }

          .edge-1 { animation-delay: 0s; }
          .edge-2 { animation-delay: 0.25s; }
          .edge-3 { animation-delay: 0.5s; }
          .edge-4 { animation-delay: 0.75s; }
          .edge-5 { animation-delay: 0.1s; }
          .edge-6 { animation-delay: 0.35s; }
          .edge-7 { animation-delay: 0.6s; }
          .edge-8 { animation-delay: 0.85s; }
          .edge-9 { animation-delay: 0.15s; }
          .edge-10 { animation-delay: 0.4s; }
          .edge-11 { animation-delay: 0.65s; }
          .edge-12 { animation-delay: 0.9s; }
          .edge-13 { animation-delay: 0.2s; }
          .edge-14 { animation-delay: 0.45s; }
          .edge-15 { animation-delay: 0.7s; }
          .edge-16 { animation-delay: 0.95s; }

          @keyframes edgeLengthChange {
            0% {
              transform: scale(0.7);
              opacity: 0.6;
            }
            25% {
              transform: scale(1.3);
              opacity: 1;
            }
            50% {
              transform: scale(0.85);
              opacity: 0.8;
            }
            75% {
              transform: scale(1.2);
              opacity: 1;
            }
            100% {
              transform: scale(0.7);
              opacity: 0.6;
            }
          }

          /* Light mode support */
          @media (prefers-color-scheme: light) {
            .sparkle-icon .edge-line {
              stroke: #0891B2;
            }
          }
        `}</style>
      )}
    </>
  );
};

export default SparkleIcon;
